import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import moment from 'moment'
import {deepClone, filterFlowUnit} from '@src/utils';
import {userStore} from '@store/userStore';

class IntegralMallStore extends StoreExt {
    @observable integralGoods: any[] = []
    @observable integralGoodsListObj = {
        dataPlan: [],
        coupon: [],
        physicalGoods: []
    }
    @observable integralGoodsDetail: any = {}
    @observable userIntegralInfo: any = {}
    @observable userIntegralRecord: any[] = []
    @observable integralOrderDetail: any = {}
    @observable signInActInfo: any = {}
    @observable showSignInModal: boolean = false

    // 积分商城列表
    @action
    getIntegralGoodsList = async () => {
        const integralGoodsObj = {
            dataPlan: [],
            coupon: [],
            physicalGoods: []
        }
        let integralGoods = []
        try {
            const res = await this.api.queryIntegralPlan({})
            integralGoodsObj.physicalGoods = res.filter(item => item.goodType === '1')
            integralGoodsObj.coupon = res.filter(item => item.goodType === '2')
            integralGoodsObj.dataPlan = res.filter(item => item.goodType === '3')
            integralGoodsObj.coupon.map(item => {
                item.validEndTime = item.couponInfo.validEndTime ? moment(item.couponInfo.validEndTime).format('YYYY/MM/DD') : null
                item.useTime = item.couponInfo.validType === '0' ? `有效期至${item.validEndTime}` : `有效期${item.couponInfo.validDays}天`
            })
            integralGoodsObj.dataPlan.map(item => {
                item.useTime = `有效期${item.goodsInfo.goodsNumber}个月 ${filterFlowUnit(item.goodsInfo.policyDegree)}/月`
            })
            integralGoods = res || []
        } catch (e) {
            console.error(e)
        } finally {
            runInAction(() => {
                this.integralGoodsListObj = integralGoodsObj
                this.integralGoods = integralGoods
            })
        }
    }

    // 积分商品详情
    @action
    getIntegralGoodsDetail = async integralId => {
        try {
            const res = await this.api.buyIntegralGoodQuery({integralId})
            res.infoLists = res.goodInfo.split('\n')
            if (res.goodType === '2') {
                res.validEndTime = res.couponInfo.validEndTime ? moment(res.couponInfo.validEndTime).format('YYYY/MM/DD') : null
                res.useTime = res.couponInfo.validType === '0' ? `有效期至${res.validEndTime}` : `有效期${res.couponInfo.validDays}天`
            }
            if (res.goodType === '3') {
                res.useTime = `有效期${res.goodsInfo.goodsNumber}个月 ${filterFlowUnit(res.goodsInfo.policyDegree)}/月`
            }
            runInAction(() => {
                this.integralGoodsDetail = res
            })
        } catch (e) {
            console.error(e)
        }
    }

    @action
    handleExchange = async (phone?: string, payment?) => {
        if (this.integralGoodsDetail.price === 0) {
            await this.exchangeByIntegral(phone)
        } else {
            await this.exchangeByIntegralAndMoney(phone, payment)
        }
    }

    // 全积分兑换流程
    @action
    exchangeByIntegral = async (phone) => {
        this.$toast.loading('兑换中，请稍后')
        const res = await this.fetchBuyIntegralGood(phone)
        this.goToPath(`/app/integral-mall/success/${res}`)
        this.$toast.hide()
    }

    // 积分 + 钱兑换流程
    @action
    exchangeByIntegralAndMoney = async (phone, payment) => {
        this.$toast.loading('订单生成中')
        const res = await this.fetchBuyIntegralGood(phone, payment)
        this.goToPath(`/app/integral-mall/submit-order/${res}/${payment}`)
        this.$toast.hide()
    }

    // 账户积分信息
    @action
    getUserIntegralInfo = async () => {
        try {
            const res = await this.api.detailCustomerIntegral({})
            runInAction(() => {
                this.userIntegralInfo = res
            })
        } catch (error) {
            console.error(error)
        }
    }

    // 积分记录
    @action
    getUserIntegralRecord = async (current: number = 1) => {
        try {
            const res = await this.api.integralRecordList({
                current: current,
                pageSize: 10
            })
            this.setUserIntegralRecord(current === 1 ? res.list : [...this.userIntegralRecord, ...res.list])
            return res.list
        } catch (error) {
            console.error(error)
        }
    }
    @action
    setUserIntegralRecord = value => {
        this.userIntegralRecord = value
    }
    // 积分订单详情
    @action
    getIntegralOrderDetail = async (orderId: string) => {
        try {
            const res = await this.api.queryIntegralOrderStatus({orderId})
            if (res.goodType === '2') {
                res.validEndTime = res.couponInfo.validEndTime ? moment(res.couponInfo.validEndTime).format('YYYY/MM/DD') : null
                res.useTime = res.couponInfo.validType === '0' ? `有效期至${res.validEndTime}` : `有效期${res.couponInfo.validDays}天`
            }
            if (res.goodType === '3') {
                res.useTime = `有效期${res.goodsInfo.goodsNumber}个月 ${filterFlowUnit(res.goodsInfo.policyDegree)}/月`
            }
            runInAction(() => {
                this.integralOrderDetail = res
            })
        } catch (e) {
            console.error(e)
        }
    }

    // 支付
    @action
    handlePay = async (orderId, payment) => {
        try {
            this.$toast.loading('支付跳转中')
            const res = await this.api.payingPlan({
                orderId: orderId,
                goodsName: this.integralOrderDetail.integralName,
                paymentType: payment,
            })
            // 微信支付
            if (payment === '1') {
                const url = deepClone(userStore.payConfig) || ''
                const eUrl = encodeURIComponent(url)
                window.location.href = `${res.resinfo}&redirect_url=${eUrl}`
            }
            // 支付宝支付
            if (payment === '2') {
                const data = res.resinfo
                const div = document.createElement('div')
                div.innerHTML = data
                document.body.appendChild(div)
                document.forms[0].submit()
            }
        } catch (e) {
            console.error(e)
        } finally {
            this.$toast.hide()
        }
    }

    // 签到活动信息
    getSignInActInfo = async () => {
        try {
            const res = await this.api.querySignInfo({})
            if (res.activityId) {
                const days = res.triggerRule === '1' ? res.continuityCnt : res.cumulativeCnt
                const dto = res.prizeList.filter(item => item.timeCount === days)
                if (dto.length > 0) {
                    const rewardNameList = []
                    dto.map(item => {
                        rewardNameList.push(item.rewardName || `${item.rewardContent}积分`)
                    })
                    res.rewardName = rewardNameList.join('，')
                }
            }
            runInAction(() => {
                this.signInActInfo = res
            })
        } catch (e) {
            console.error(e)
        }
    }

    // 签到
    @action
    doSignIn = async (showModal: boolean = false) => {
        try {
            if (this.signInActInfo.signed) {
                return
            }
            await this.api.signIn({})
            await this.getSignInActInfo()
            if (showModal) {
                this.setSignInModal(true)
            } else {
                this.$toast.info(`签到成功，+${this.signInActInfo.confVal}积分`)
            }
        } catch (e) {
            console.error(e)
        }
    }
    @action
    setSignInModal = (value: boolean) => {
        this.showSignInModal = value
    }
    private fetchBuyIntegralGood = async (phone, paymentType?) => {
        return await this.api.buyIntegralGood({
            integralId: this.integralGoodsDetail.integralId,
            paymentType: paymentType || '1',
            cargoType: '0',
            phone: phone
        })
    }
}

const integralMallStore = new IntegralMallStore()
export {integralMallStore, IntegralMallStore}
